import InfiniteScroll from 'infinite-scroll';

export const initInfiniteScroll = function () {
  const debug = process.env.NODE_ENV === 'development';
  const container = document.querySelector('.projects-holder');
  if (container) {
    const infiniteScroll = new InfiniteScroll(container, {
      path: function () {
        let pageNumber = (this.loadCount + 1) * 4;
        let link = window.location.href;
        if (link.includes('?')) {
          return link + '&start=' + pageNumber;
        } else {
          return link + '?start=' + pageNumber;
        }
      },
      append: '.project-preview-slice',
      hideNav: '.pagination-slice__pagination',
      status: '.infinite-status',
      checkLastPage: '.pagination__item--next a',
      history: false,
      debug: debug
    });

    infiniteScroll.on( 'append', ( response, path, items ) => {
      if (items.length) {
        items.forEach((item, index) => {
          setTimeout(() => {
            $(item).removeClass('project-preview-slice--hidden');
          }, index * 150);
        });
      }
    });
  }
};